import PseudoStringBuilder from 'sas-pseudol10n4js/src/PseudoL10nString';

const pseudoString = PseudoStringBuilder('');

const getStrategy = (locale: string) => {
  return pseudoString._strategies[getStrategyName(locale)];
};

const getStrategyName = (strategy: string) => {
  strategy = strategy.toLowerCase();
  switch (strategy) {
    case 'zh-cn-pseudo':
      return 'zh_CN_pseudo';
    case 'ar-xx':
      return 'ar_XX';
    case 'pl-xx':
    default:
      return 'pl_XX';
  }
};

/**
 * Pseudo-localize a string for the locale
 *
 * @param {string} locale Name of locale
 * @param {string} str The string to pseudo-localize
 * @return {string}
 */
export const pseudoLocalizeStringForLocale = (locale: string, str: string) => {
  if (str && str.length < 1) return str;
  const strategy = getStrategy(locale);
  return pseudoString._transformString(strategy, str);
};

/**
 * Pseudo-translates the provided bundle to the pseudo-locale.
 *
 * @param locale locale to pseudo-translate to
 * @param bundle an object of message keys and messages
 * @returns
 */
export const pseudoLocalizeBundle = (
  locale: string,
  bundle: Record<string, string>
): Record<string, string> => {
  if (!bundle) {
    return bundle;
  }
  const newBundle = {} as Record<string, string>;
  Object.keys(bundle).forEach((k) => {
    // Skip translation for below type of keys in pseudo langauges
    if (/[._](notrans|lcl|image|classname|gif)$/i.test(k)) newBundle[k] = bundle[k];
    else newBundle[k] = pseudoLocalizeStringForLocale(locale, bundle[k]);
  });
  return newBundle;
};
